import { FC } from 'react'

import { IconName, List, ListItem } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { Organization } from '../domain/organization'

const sidebarItems = ['organization', 'legal-entities', 'contacts', 'locations', 'customs-deferment-accounts'] as const
type SidebarItemsType = (typeof sidebarItems)[number]
const IconMap: Record<SidebarItemsType, IconName> = {
  organization: 'Domain',
  'legal-entities': 'Domain',
  contacts: 'People',
  locations: 'Location',
  'customs-deferment-accounts': 'CheckMark',
}

const countMap: Partial<Record<SidebarItemsType, keyof Organization>> = {
  'legal-entities': 'legalEntityIds',
  contacts: 'contactIds',
  locations: 'locationIds',
}

type CompanyAccountSidebarProps = {
  organization?: Organization
}

export const CompanyAccountSidebar: FC<CompanyAccountSidebarProps> = ({ organization }) => {
  const { translate } = useLocalisation()

  return (
    <List>
      {sidebarItems.map((item) => {
        const count = countMap[item] && organization ? (organization[countMap[item]] as string[])?.length : 0
        return (
          <ListItem key={item} icon={IconMap[item]} href={`#${item}`}>
            {translate(`company-account.sidebar.${item}`)}
            {!!count && ` (${count})`}
          </ListItem>
        )
      })}
    </List>
  )
}
